import { Injectable } from '@angular/core';
import { environment } from "environments/environment";
import { GrafanaConfiguration } from "./grafana-configuration.model";

@Injectable({
    providedIn: 'root'
})
export class GrafanaConfigurationService {
    getConfiguration() : GrafanaConfiguration {
        const configurationSection = environment['grafana']
        if (configurationSection === null) {
            return GrafanaConfiguration.defaultConfiguration;
        }

        return configurationSection;
    }
}